import { RuleActionType } from '@jupiterone/jupiter-types';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import JiraIcon from '@jupiterone/react-brand-icons/jupiterone/jira';
import WebhookIcon from '@jupiterone/react-brand-icons/jupiterone/webhook';
import { Tooltip } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import SNSIcon from 'react-aws-icons/dist/aws/logo/SNS';
import SQSIcon from 'react-aws-icons/dist/aws/logo/SQS';
import AlertIcon from 'react-feather/dist/icons/bell';
import EmailIcon from 'react-feather/dist/icons/mail';
import SlackIcon from 'react-feather/dist/icons/slack';
import { ServiceNowIcon } from '@jupiterone/jupiter-web-toolkit';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    icon: {
      alignItems: 'center',
      background: theme.palette.coolGrey[50],
      border: 'solid 1px ' + theme.palette.coolGrey[100],
      borderRadius: '50%',
      color: theme.palette.coolGrey[600],
      display: 'inline-flex',
      margin: theme.spacing(0, 0.5, 0, 0),
      padding: theme.spacing(0.75),
      '& span': {
        height: theme.spacing(2),
      },
      '& svg': {
        stroke: 'currentColor',
        height: theme.spacing(2),
        width: theme.spacing(2),
      },
    },
    noBorder: {
      border: 'none',
    },
  })
);

interface Props {
  action: RuleActionType;
  noBorder?: boolean;
}

const RuleOutputIcon = ({ action, noBorder }: Props) => {
  const classes = useStyles();
  let icon;
  switch (action) {
    case RuleActionType.CREATE_ALERT:
      icon = <AlertIcon />;
      break;
    case RuleActionType.SEND_EMAIL:
      icon = <EmailIcon />;
      break;
    case RuleActionType.SEND_SLACK_MESSAGE:
      icon = <SlackIcon />;
      break;
    case RuleActionType.CREATE_JIRA_TICKET:
      icon = <JiraIcon />;
      break;
    case RuleActionType.CREATE_SERVICE_NOW_INCIDENT:
      icon = <ServiceNowIcon size={24} />;
      break;
    case RuleActionType.PUBLISH_SNS_MESSAGE:
      icon = <SNSIcon />;
      break;
    case RuleActionType.SEND_SQS_MESSAGE:
      icon = <SQSIcon />;
      break;
    case RuleActionType.WEBHOOK:
      icon = <WebhookIcon />;
      break;
    default:
      return <>{false}</>;
  }

  return (
    <div className={clsx(classes.icon, noBorder && classes.noBorder)}>
      <Tooltip title={action}>
        <span>{icon}</span>
      </Tooltip>
    </div>
  );
};

export default RuleOutputIcon;
